/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createVideoURLs = /* GraphQL */ `
  mutation CreateVideoURLs(
    $input: CreateVideoURLsInput!
    $condition: ModelVideoURLsConditionInput
  ) {
    createVideoURLs(input: $input, condition: $condition) {
      id
      guid
      srcvideo
      MP4
      CMAF
      HLS
      DASH
      MSS
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateVideoURLs = /* GraphQL */ `
  mutation UpdateVideoURLs(
    $input: UpdateVideoURLsInput!
    $condition: ModelVideoURLsConditionInput
  ) {
    updateVideoURLs(input: $input, condition: $condition) {
      id
      guid
      srcvideo
      MP4
      CMAF
      HLS
      DASH
      MSS
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteVideoURLs = /* GraphQL */ `
  mutation DeleteVideoURLs(
    $input: DeleteVideoURLsInput!
    $condition: ModelVideoURLsConditionInput
  ) {
    deleteVideoURLs(input: $input, condition: $condition) {
      id
      guid
      srcvideo
      MP4
      CMAF
      HLS
      DASH
      MSS
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createVideo = /* GraphQL */ `
  mutation CreateVideo(
    $input: CreateVideoInput!
    $condition: ModelVideoConditionInput
  ) {
    createVideo(input: $input, condition: $condition) {
      id
      title
      description
      url
      poster
      duration
      date
      category {
        id
        name
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      teacher {
        id
        name
        image
        bio
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tags {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      categoryVideosId
      teacherVideosId
      __typename
    }
  }
`;
export const updateVideo = /* GraphQL */ `
  mutation UpdateVideo(
    $input: UpdateVideoInput!
    $condition: ModelVideoConditionInput
  ) {
    updateVideo(input: $input, condition: $condition) {
      id
      title
      description
      url
      poster
      duration
      date
      category {
        id
        name
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      teacher {
        id
        name
        image
        bio
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tags {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      categoryVideosId
      teacherVideosId
      __typename
    }
  }
`;
export const deleteVideo = /* GraphQL */ `
  mutation DeleteVideo(
    $input: DeleteVideoInput!
    $condition: ModelVideoConditionInput
  ) {
    deleteVideo(input: $input, condition: $condition) {
      id
      title
      description
      url
      poster
      duration
      date
      category {
        id
        name
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      teacher {
        id
        name
        image
        bio
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tags {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      categoryVideosId
      teacherVideosId
      __typename
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      name
      description
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      name
      description
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      name
      description
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacher = /* GraphQL */ `
  mutation CreateTeacher(
    $input: CreateTeacherInput!
    $condition: ModelTeacherConditionInput
  ) {
    createTeacher(input: $input, condition: $condition) {
      id
      name
      image
      bio
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTeacher = /* GraphQL */ `
  mutation UpdateTeacher(
    $input: UpdateTeacherInput!
    $condition: ModelTeacherConditionInput
  ) {
    updateTeacher(input: $input, condition: $condition) {
      id
      name
      image
      bio
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTeacher = /* GraphQL */ `
  mutation DeleteTeacher(
    $input: DeleteTeacherInput!
    $condition: ModelTeacherConditionInput
  ) {
    deleteTeacher(input: $input, condition: $condition) {
      id
      name
      image
      bio
      videos {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTag = /* GraphQL */ `
  mutation CreateTag(
    $input: CreateTagInput!
    $condition: ModelTagConditionInput
  ) {
    createTag(input: $input, condition: $condition) {
      id
      name
      video {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTag = /* GraphQL */ `
  mutation UpdateTag(
    $input: UpdateTagInput!
    $condition: ModelTagConditionInput
  ) {
    updateTag(input: $input, condition: $condition) {
      id
      name
      video {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTag = /* GraphQL */ `
  mutation DeleteTag(
    $input: DeleteTagInput!
    $condition: ModelTagConditionInput
  ) {
    deleteTag(input: $input, condition: $condition) {
      id
      name
      video {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUserData = /* GraphQL */ `
  mutation CreateUserData(
    $input: CreateUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    createUserData(input: $input, condition: $condition) {
      id
      cognitoSub
      favorites
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUserData = /* GraphQL */ `
  mutation UpdateUserData(
    $input: UpdateUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    updateUserData(input: $input, condition: $condition) {
      id
      cognitoSub
      favorites
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUserData = /* GraphQL */ `
  mutation DeleteUserData(
    $input: DeleteUserDataInput!
    $condition: ModelUserDataConditionInput
  ) {
    deleteUserData(input: $input, condition: $condition) {
      id
      cognitoSub
      favorites
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCourse = /* GraphQL */ `
  mutation CreateCourse(
    $input: CreateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    createCourse(input: $input, condition: $condition) {
      id
      title
      description
      image
      modules {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCourse = /* GraphQL */ `
  mutation UpdateCourse(
    $input: UpdateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    updateCourse(input: $input, condition: $condition) {
      id
      title
      description
      image
      modules {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCourse = /* GraphQL */ `
  mutation DeleteCourse(
    $input: DeleteCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    deleteCourse(input: $input, condition: $condition) {
      id
      title
      description
      image
      modules {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCourseModule = /* GraphQL */ `
  mutation CreateCourseModule(
    $input: CreateCourseModuleInput!
    $condition: ModelCourseModuleConditionInput
  ) {
    createCourseModule(input: $input, condition: $condition) {
      id
      courseID
      moduleID
      course {
        id
        title
        description
        image
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCourseModule = /* GraphQL */ `
  mutation UpdateCourseModule(
    $input: UpdateCourseModuleInput!
    $condition: ModelCourseModuleConditionInput
  ) {
    updateCourseModule(input: $input, condition: $condition) {
      id
      courseID
      moduleID
      course {
        id
        title
        description
        image
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCourseModule = /* GraphQL */ `
  mutation DeleteCourseModule(
    $input: DeleteCourseModuleInput!
    $condition: ModelCourseModuleConditionInput
  ) {
    deleteCourseModule(input: $input, condition: $condition) {
      id
      courseID
      moduleID
      course {
        id
        title
        description
        image
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createModule = /* GraphQL */ `
  mutation CreateModule(
    $input: CreateModuleInput!
    $condition: ModelModuleConditionInput
  ) {
    createModule(input: $input, condition: $condition) {
      id
      title
      description
      courses {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateModule = /* GraphQL */ `
  mutation UpdateModule(
    $input: UpdateModuleInput!
    $condition: ModelModuleConditionInput
  ) {
    updateModule(input: $input, condition: $condition) {
      id
      title
      description
      courses {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteModule = /* GraphQL */ `
  mutation DeleteModule(
    $input: DeleteModuleInput!
    $condition: ModelModuleConditionInput
  ) {
    deleteModule(input: $input, condition: $condition) {
      id
      title
      description
      courses {
        nextToken
        startedAt
        __typename
      }
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createModuleLesson = /* GraphQL */ `
  mutation CreateModuleLesson(
    $input: CreateModuleLessonInput!
    $condition: ModelModuleLessonConditionInput
  ) {
    createModuleLesson(input: $input, condition: $condition) {
      id
      moduleID
      lessonID
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateModuleLesson = /* GraphQL */ `
  mutation UpdateModuleLesson(
    $input: UpdateModuleLessonInput!
    $condition: ModelModuleLessonConditionInput
  ) {
    updateModuleLesson(input: $input, condition: $condition) {
      id
      moduleID
      lessonID
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteModuleLesson = /* GraphQL */ `
  mutation DeleteModuleLesson(
    $input: DeleteModuleLessonInput!
    $condition: ModelModuleLessonConditionInput
  ) {
    deleteModuleLesson(input: $input, condition: $condition) {
      id
      moduleID
      lessonID
      module {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createLesson = /* GraphQL */ `
  mutation CreateLesson(
    $input: CreateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    createLesson(input: $input, condition: $condition) {
      id
      title
      content
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      videoID
      modules {
        nextToken
        startedAt
        __typename
      }
      faqItems {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      videoLessonsId
      __typename
    }
  }
`;
export const updateLesson = /* GraphQL */ `
  mutation UpdateLesson(
    $input: UpdateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    updateLesson(input: $input, condition: $condition) {
      id
      title
      content
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      videoID
      modules {
        nextToken
        startedAt
        __typename
      }
      faqItems {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      videoLessonsId
      __typename
    }
  }
`;
export const deleteLesson = /* GraphQL */ `
  mutation DeleteLesson(
    $input: DeleteLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    deleteLesson(input: $input, condition: $condition) {
      id
      title
      content
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      videoID
      modules {
        nextToken
        startedAt
        __typename
      }
      faqItems {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      videoLessonsId
      __typename
    }
  }
`;
export const createToolCategory = /* GraphQL */ `
  mutation CreateToolCategory(
    $input: CreateToolCategoryInput!
    $condition: ModelToolCategoryConditionInput
  ) {
    createToolCategory(input: $input, condition: $condition) {
      id
      title
      description
      tools {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateToolCategory = /* GraphQL */ `
  mutation UpdateToolCategory(
    $input: UpdateToolCategoryInput!
    $condition: ModelToolCategoryConditionInput
  ) {
    updateToolCategory(input: $input, condition: $condition) {
      id
      title
      description
      tools {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteToolCategory = /* GraphQL */ `
  mutation DeleteToolCategory(
    $input: DeleteToolCategoryInput!
    $condition: ModelToolCategoryConditionInput
  ) {
    deleteToolCategory(input: $input, condition: $condition) {
      id
      title
      description
      tools {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTool = /* GraphQL */ `
  mutation CreateTool(
    $input: CreateToolInput!
    $condition: ModelToolConditionInput
  ) {
    createTool(input: $input, condition: $condition) {
      id
      title
      url
      toolCategoryID
      toolCategory {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      toolCategoryToolsId
      __typename
    }
  }
`;
export const updateTool = /* GraphQL */ `
  mutation UpdateTool(
    $input: UpdateToolInput!
    $condition: ModelToolConditionInput
  ) {
    updateTool(input: $input, condition: $condition) {
      id
      title
      url
      toolCategoryID
      toolCategory {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      toolCategoryToolsId
      __typename
    }
  }
`;
export const deleteTool = /* GraphQL */ `
  mutation DeleteTool(
    $input: DeleteToolInput!
    $condition: ModelToolConditionInput
  ) {
    deleteTool(input: $input, condition: $condition) {
      id
      title
      url
      toolCategoryID
      toolCategory {
        id
        title
        description
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      toolCategoryToolsId
      __typename
    }
  }
`;
export const createUserProgress = /* GraphQL */ `
  mutation CreateUserProgress(
    $input: CreateUserProgressInput!
    $condition: ModelUserProgressConditionInput
  ) {
    createUserProgress(input: $input, condition: $condition) {
      id
      userID
      courseID
      moduleProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUserProgress = /* GraphQL */ `
  mutation UpdateUserProgress(
    $input: UpdateUserProgressInput!
    $condition: ModelUserProgressConditionInput
  ) {
    updateUserProgress(input: $input, condition: $condition) {
      id
      userID
      courseID
      moduleProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUserProgress = /* GraphQL */ `
  mutation DeleteUserProgress(
    $input: DeleteUserProgressInput!
    $condition: ModelUserProgressConditionInput
  ) {
    deleteUserProgress(input: $input, condition: $condition) {
      id
      userID
      courseID
      moduleProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createModuleProgress = /* GraphQL */ `
  mutation CreateModuleProgress(
    $input: CreateModuleProgressInput!
    $condition: ModelModuleProgressConditionInput
  ) {
    createModuleProgress(input: $input, condition: $condition) {
      id
      userID
      userProgressID
      moduleID
      userProgress {
        id
        userID
        courseID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lessonProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateModuleProgress = /* GraphQL */ `
  mutation UpdateModuleProgress(
    $input: UpdateModuleProgressInput!
    $condition: ModelModuleProgressConditionInput
  ) {
    updateModuleProgress(input: $input, condition: $condition) {
      id
      userID
      userProgressID
      moduleID
      userProgress {
        id
        userID
        courseID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lessonProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteModuleProgress = /* GraphQL */ `
  mutation DeleteModuleProgress(
    $input: DeleteModuleProgressInput!
    $condition: ModelModuleProgressConditionInput
  ) {
    deleteModuleProgress(input: $input, condition: $condition) {
      id
      userID
      userProgressID
      moduleID
      userProgress {
        id
        userID
        courseID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lessonProgress {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createLessonProgress = /* GraphQL */ `
  mutation CreateLessonProgress(
    $input: CreateLessonProgressInput!
    $condition: ModelLessonProgressConditionInput
  ) {
    createLessonProgress(input: $input, condition: $condition) {
      id
      userID
      lessonID
      moduleID
      moduleProgressID
      moduleProgress {
        id
        userID
        userProgressID
        moduleID
        progressPercentage
        completed
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lastViewedAt
      lastWatchedPosition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateLessonProgress = /* GraphQL */ `
  mutation UpdateLessonProgress(
    $input: UpdateLessonProgressInput!
    $condition: ModelLessonProgressConditionInput
  ) {
    updateLessonProgress(input: $input, condition: $condition) {
      id
      userID
      lessonID
      moduleID
      moduleProgressID
      moduleProgress {
        id
        userID
        userProgressID
        moduleID
        progressPercentage
        completed
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lastViewedAt
      lastWatchedPosition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteLessonProgress = /* GraphQL */ `
  mutation DeleteLessonProgress(
    $input: DeleteLessonProgressInput!
    $condition: ModelLessonProgressConditionInput
  ) {
    deleteLessonProgress(input: $input, condition: $condition) {
      id
      userID
      lessonID
      moduleID
      moduleProgressID
      moduleProgress {
        id
        userID
        userProgressID
        moduleID
        progressPercentage
        completed
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      progressPercentage
      completed
      lastViewedAt
      lastWatchedPosition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createFAQItem = /* GraphQL */ `
  mutation CreateFAQItem(
    $input: CreateFAQItemInput!
    $condition: ModelFAQItemConditionInput
  ) {
    createFAQItem(input: $input, condition: $condition) {
      id
      question
      answer
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateFAQItem = /* GraphQL */ `
  mutation UpdateFAQItem(
    $input: UpdateFAQItemInput!
    $condition: ModelFAQItemConditionInput
  ) {
    updateFAQItem(input: $input, condition: $condition) {
      id
      question
      answer
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteFAQItem = /* GraphQL */ `
  mutation DeleteFAQItem(
    $input: DeleteFAQItemInput!
    $condition: ModelFAQItemConditionInput
  ) {
    deleteFAQItem(input: $input, condition: $condition) {
      id
      question
      answer
      lessons {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createLessonFAQItem = /* GraphQL */ `
  mutation CreateLessonFAQItem(
    $input: CreateLessonFAQItemInput!
    $condition: ModelLessonFAQItemConditionInput
  ) {
    createLessonFAQItem(input: $input, condition: $condition) {
      id
      lessonID
      faqItemID
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      faqItem {
        id
        question
        answer
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateLessonFAQItem = /* GraphQL */ `
  mutation UpdateLessonFAQItem(
    $input: UpdateLessonFAQItemInput!
    $condition: ModelLessonFAQItemConditionInput
  ) {
    updateLessonFAQItem(input: $input, condition: $condition) {
      id
      lessonID
      faqItemID
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      faqItem {
        id
        question
        answer
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteLessonFAQItem = /* GraphQL */ `
  mutation DeleteLessonFAQItem(
    $input: DeleteLessonFAQItemInput!
    $condition: ModelLessonFAQItemConditionInput
  ) {
    deleteLessonFAQItem(input: $input, condition: $condition) {
      id
      lessonID
      faqItemID
      lesson {
        id
        title
        content
        videoID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        videoLessonsId
        __typename
      }
      faqItem {
        id
        question
        answer
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createVideoTags = /* GraphQL */ `
  mutation CreateVideoTags(
    $input: CreateVideoTagsInput!
    $condition: ModelVideoTagsConditionInput
  ) {
    createVideoTags(input: $input, condition: $condition) {
      id
      videoId
      tagId
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      tag {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateVideoTags = /* GraphQL */ `
  mutation UpdateVideoTags(
    $input: UpdateVideoTagsInput!
    $condition: ModelVideoTagsConditionInput
  ) {
    updateVideoTags(input: $input, condition: $condition) {
      id
      videoId
      tagId
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      tag {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteVideoTags = /* GraphQL */ `
  mutation DeleteVideoTags(
    $input: DeleteVideoTagsInput!
    $condition: ModelVideoTagsConditionInput
  ) {
    deleteVideoTags(input: $input, condition: $condition) {
      id
      videoId
      tagId
      video {
        id
        title
        description
        url
        poster
        duration
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        categoryVideosId
        teacherVideosId
        __typename
      }
      tag {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
